<template>
  <div id="slate-int-calculator-input">
    <div>
      <h1 class="input-title"><slot name="title"></slot></h1>
      <div class="fields"> 
        <div class="field-group" v-for="fieldGroup of fieldGroups">
          <h2 class="field-group-title" v-if="fieldGroup.name">{{ fieldGroup.name }}</h2>
          <table class="field-group-fields">
            <tr class="field" v-for="field of fieldGroup.fields" :key="field.id">
              <td class="field-label">
                <label :for="field.name">{{ field.label }}</label>
              </td>
              <td class="field-input">
                <template v-if="field.type === 'text'">
                  <input :name="field.name" :type="field.type" :placeholder="field.placeholder" :value="field.value" v-on:input="modifyData(field, $event)" @keyup.enter="trySubmit">
                </template>
                <template v-if="field.type === 'radio'">
                  <span class="radio-group">
                    <span class="radio-input" v-for="(option, index) of field.options">
                      <input :name="field.name" :type="field.type" :value="option.value" :disabled="option.disabled" :checked="option.checked" v-on:change="modifyData(field, $event); checkButton(field, option)"><span class="radio-text">{{ option.text }}</span>
                    </span>
                  </span>
                </template>
                <template v-if="field.type === 'select'">
                  <select v-on:input="modifyData(field, $event)">
                    <option selected disabled>{{ field.defaultOption }}</option>
                    <option v-for="option of field.options" :value="option.value">{{ option.text }}</option>
                  </select>
                </template>
                <template v-if="field.validate">
                  <div class="field-warning" v-show="field.warning">
                    {{ field.valid.message }}
                  </div>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="submit">
        <custom-button :class="{isValid: allFieldsValid}" v-on:customButtonClick="trySubmit"><slot name="button"></slot></custom-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import CustomButton from '../../.././slate-int-custom-button/src/CustomButton'

export default {
  name: 'calculatorInput',
  props: ['fieldGroups'],
  data () {
    return {
      allFieldsValid: false
    }
  },
  methods: {
    modifyData (field, $event) {
      field.value = $event.target.value
      if (field.validate) this.validateField(field)
      else this.checkAllFields()
    },
    checkButton (field, option) {
      field.options.forEach((option) => { option.checked = false })
      option.checked = true
    },
    validateField (field) {
      const db = _.debounce(
        () => {
          field.valid = field.validate(field.value)
          field.warning = field.valid.blank ? false : (field.valid.message !== 'valid')
          this.checkAllFields()
        },
        500
      )

      db()
    },
    checkAllFields () {
      this.allFieldsValid = this.fieldGroups.every((fieldGroup) => {
        return fieldGroup.fields.every((field) => {
          return field.valid.message === 'valid'
        })
      })
    },
    trySubmit () {
      if (this.allFieldsValid) this.submitData()
      else return
    },
    submitData () {
      this.$emit('submitData')
    }
  },
  components: {
    'custom-button': CustomButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#slate-int-calculator-input {
  text-align: center;
}
.input-title {
  font-family: sl-TitlingGothicFBCondensed, helvetica, sans-serif;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 2.5em;
}
.fields {
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  margin: 5% 0;
}
.field {
  text-align: left;
  font-size: 1em;
}
.field-label, .field-input {
  padding: 0.5em 0.5em;
}
.field:first-child .field-label,
.field:first-child .field-input {
  padding-top: 0;
}
.field:last-child .field-label,
.field:last-child .field-input {
  padding-bottom: 0;
}
.field-label {
  vertical-align: top;
}
.field-input {
  vertical-align: top;
}
.field-warning {
  font-size: 0.8em;
  margin-top: 3px;
  color: red;
}
input {
  padding: 0.5em;
}
.radio-input {
  margin-left: 0.5em;
}
.radio-input:first-child {
  margin-left: 0;
}
.radio-text {
  margin-left: 0.3em;
}
@media only screen and (max-width: 583px) {
  tr {
    width: 100%;
    border-bottom: 1px solid #c7c7c7;
  }
  tr:last-child {
    border-bottom: none;
  }
  td {
    display: inline-block;
    width: 100%;
  }
  .field-input {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// CalculatorInput.vue?791a6c41